import { Controller } from '@hotwired/stimulus';
import { expandCommentsInThread } from '@components/comments/comment_thread/component_controller';
import { updateReadMoreButtonVisibility } from '@components/comments/comment/component_controller';
import { reload as reloadLazyPartial } from '@controllers/main/lazy-partial_controller';
import { displayReset, hide } from '@frontend/utils/dom';
import CurrentPage from '@frontend/app/features/CurrentPage';

export default class extends Controller {
  static targets = [
    'commentThreadsContainer',
    'showAllCommentThreadsButton',
    'comment',
    'lazyPartial',
  ];

  connect() {
    if (CurrentPage.isDeepLinkingToComment()) {
      this.showAllCommentThreads();
    }
  }

  reload(_event) {
    if (this.hasShowAllCommentThreadsButtonTarget) {
      this.showAllCommentThreads();
    }

    reloadLazyPartial(this.lazyPartialTarget);
  }

  showAllCommentThreads() {
    hide(this.showAllCommentThreadsButtonTarget);
    displayReset(this.commentThreadsContainerTarget);
    this.commentTargets.forEach((target) =>
      updateReadMoreButtonVisibility(target)
    );
  }

  scrollToComment(event) {
    this.scrollToCommentById(event.params.id);
  }

  scrollToCommentById(id) {
    if (this.hasShowAllCommentThreadsButtonTarget) {
      this.showAllCommentThreads();
    }

    const commentId = `#comment-${id}`;
    const commentElement = this.element.querySelector(commentId);
    expandCommentsInThread(commentElement);

    // NB: The scroll event is called more often than every 100ms, so whenever
    // scrolling ended, the event handler will be cleared.
    let scrollTimeout;
    window.addEventListener('scroll', function callback() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        window.location.hash = commentId;
        window.removeEventListener('scroll', callback);
      }, 100);
    });

    setTimeout(() => {
      commentElement.scrollIntoView({ behavior: 'instant', block: 'start' });
    }, 500);
  }
}
